<template>
  <!-- コメント本文 入力 -->
  <div class="comment-input__inner">
    <div class="comment-input__header">
      <user-info :userData="user2"></user-info>
    </div>
    <div class="comment-input__body" v-if="!isConfirm">
      <textarea
        class="textarea"
        :class="{ 'textarea--error': this.isError }"
        placeholder="コメントを入力してください。"
        v-model="comment"
        @keyup="autoResize"
        ref="inputElm"
        :style="textStyle"
      ></textarea>
      <div
        class="textarea__count"
        :class="{ 'textarea__count--error': this.isError }"
      >{{commentLength}}/{{commentMax}}</div>
    </div>
    <!-- コメント本文 確認 -->
    <div class="comment-input__body" v-else>
      <p class="comment-input__check" v-text="comment"></p>
    </div>
    <div class="comment-input__footer">
      <a
        href="https://www.j-cast.com/etc/comment_guide.html"
        class="text-link"
        target="_blank"
      >コメントガイドライン</a>

      <!-- コメント操作ボタン 確認 -->
      <div class="comment-input-btn-group" v-if="user && user.display_name">
        <button class="btn btn-has-bg btn-submit" type="button" @click="addRoleHandler">
          <span class="btn-text">コメント機能を許可して投稿</span>
        </button>
      </div>
      <div class="comment-input-btn-group" v-else>
        <button class="btn btn-edit" type="button" @click="loginHandler">
          <span class="btn-text">ログインして投稿</span>
        </button>
        <button class="btn btn-has-bg btn-submit" type="button" @click="registerHandler">
          <span class="btn-text">会員登録して投稿</span>
        </button>
      </div>
    </div>
    <div class="nologin-image">
      <picture>
          <source
            media="(min-width: 768px)"
            srcset="/assets_common/comment/img/comment-nologin@2x.png"
          />
          <source
            media="(max-width: 767px)"
            srcset="/assets_common/comment/img/comment-nologin-sp@2x.png"
          />
        <img src="/assets_common/comment/img/comment-nologin@2x.png" alt="コメントするには会員登録が必要です">
      </picture>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import userInfo from '../../molecules/userInfo/userInfo'
export default {
  components: {
    'user-info': userInfo
  },
  props: {
    commentMax: {
      Type: Number,
      default: 400
    },
    user: {
      type: Object
    }
  },
  data () {
    return {
      confirm: false,
      postComment: '',
      textStyle: {}
    }
  },
  computed: {
    ...mapState('commentsData', ['entryID']),
    isConfirm () {
      return this.confirm
    },
    user2 () {
      const user = {}
      if (this.user && this.user.display_name) {
        user.display_name = this.user.display_name
      } else {
        user.display_name = 'ログインしてコメントを書く'
      }
      return user
    },
    comment: {
      get () {
        return this.postComment
      },
      set (val) {
        this.postComment = val
          .replace(/(\r\n)|\n/g, '<br>')
          .replace(/(<br>){2,}/g, '<br><br>')
          .replace(/\s+/g, ' ')
          .replace(/<br>/g, '\n')
      }
    },
    commentLength () {
      return this.postComment.length
    },
    isComment () {
      return this.postComment.length > 0
    },
    isError: function () {
      return this.commentLength > this.postCommentMax
    }
  },
  methods: {
    autoResize () {
      const el = this.$refs.inputElm
      const style = { lineHeight: '22px' }
      if (el.scrollHeight > el.offsetHeight) {
        style.height = el.scrollHeight + 'px'
      } else {
        style.height = el.scrollHeight + 'px'
        if (el.scrollHeight > el.offsetHeight) {
          style.height = el.scrollHeight + 'px'
        }
      }
      if (this.commentLength < 1) {
        style.height = 'auto'
      }
      this.textStyle = style
    },
    confirmHandler () {
      this.confirm = true
    },
    loginHandler () {
      try {
        const comment = {
          comment: this.comment,
          expired_at: new Date().getTime() + 60 * 60 * 1000
        }
        localStorage.setItem(`before_${this.entryID}`, JSON.stringify(comment))
      } catch (e) {
        return false
      }
      global.loginModal('newsComment')
    },
    registerHandler () {
      try {
        const comment = {
          comment: this.comment,
          expired_at: new Date().getTime() + 60 * 60 * 1000
        }
        localStorage.setItem(`before_${this.entryID}`, JSON.stringify(comment))
      } catch (e) {
        return false
      }
      const url = encodeURI(document.location.href)
      const apiDomain = document.URL.match('dev-www') ? 'dev-id.j-cast.com' : 'id.j-cast.com'
      document.location.href = `https://${apiDomain}/account/register?jrole=r-q7sDbkJB&jorig=NewsComment&jrettxt=5YWD44Gu44Oa44O844K444Gr5oi744KL&jreturl=https%3A%2F%2F${apiDomain}%2Fexternal%2Flogin%3Fsite_id%3Ds-yXnV5AwD%26ret_url%3D${url}`
    },
    addRoleHandler () {
      try {
        const comment = {
          comment: this.comment,
          expired_at: new Date().getTime() + 60 * 60 * 1000
        }
        localStorage.setItem(`before_${this.entryID}`, JSON.stringify(comment))
      } catch (e) {
        return false
      }
      global.rankupModal('newsComment')
    }
  }
}
</script>

<style lang="scss" scoped>
.nologin-image {
  margin-top: 1rem;
  text-align: center;
   img {
    width: 100%;
  }
}

.comment-input__footer {
  @media screen and (max-width:768px) {
    flex-direction: column;
    text-align: center;
    .text-link {
      margin-bottom: 12px;
    }
  }
}

.comment-input-btn-group {
  @media screen and (max-width:768px) {
    flex-direction: column;
    .btn-submit {
      margin: 12px 0 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/organisms/beforeLoginCommentInput/index.vue